export class SearchRequest {
  input: string;
  searchType: SearchItems;

  constructor(input: string, searchType: SearchItems) {
    this.input = input;
    this.searchType = searchType;
  }
}

export enum SearchItems {
  APPS = "App" as any
}
